export default "__VITE_ASSET__CNmBg5yt__"